module.exports = __webpack_public_path__ + "static/media/housing_society.80f41e8c.svg";